// Loads one CRM 2.0 booking card from the server (M3-F2). Reloads when the booking's status or
// CRM row changes (Home's realtime listener patches the allotment), every minute while waiting for
// a Relationship Manager or a review draft, and after any customer action (reload()).
import { useCallback, useEffect, useState } from "react";
import { getCrm2Card } from "../../../Services/Crm2Booking";

const POLL_MS = 60 * 1000;

export default function useCrm2Card(allotment) {
	const apId = allotment?.isCrm2 ? allotment.allotmentPaymentId : null;
	const [card, setCard] = useState(null);
	const [failed, setFailed] = useState(null);
	const crmKey = JSON.stringify((allotment?.CRM || []).map((c) => [c.crmUserId?.userId || c.crmUserId, c.crmStatusId, c.finalReviewApprovedAt, c.finalDraftConfirmedAt]));

	const reload = useCallback(() => {
		if (!apId) return Promise.resolve(null);
		return getCrm2Card(apId)
			.then((data) => {
				setFailed(null);
				setCard(data?.isCrm2 ? data : null);
				return data;
			})
			.catch((err) => {
				console.warn("[crm2][portal] card not loaded", apId, err.message);
				setFailed(err.message);
				return null;
			});
	}, [apId]);

	useEffect(() => {
		reload();
	}, [reload, allotment?.status, allotment?.last_updated_at, crmKey]);

	const waiting = card?.bookingState === "WAITING_RM" || card?.reviewDraft?.status === "GENERATING";
	useEffect(() => {
		if (!waiting) return;
		const id = setInterval(reload, POLL_MS);
		return () => clearInterval(id);
	}, [waiting, reload]);

	return { card, failed, reload };
}
